<template>
  <div class="step-template">

    <div class="bg-primary-100 border border-primary-400 text-primary-700 px-4 py-3 rounded relative mb-4 bg-opacity-25" role="alert" v-if="templates.length === 0">
      <span class="block sm:inline">
        Você deve criar um template para realizar consulta em lote.
      </span>
      <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
    </div>

    <validation-provider v-slot="{ errors }" rules="required">
      <div class="form-group">
        <label class="label" for="templates">Consultar por Template</label>

        <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
          <multiselect
            :options="templates"
            :multiple="false"
            class="form-control"
            label="name"
            track-by="id"
            id="templates"
            placeholder="Selecione uma opção"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Pressione enter para remover"
            v-model="form.template"
            :allow-empty="true"
          ></multiselect>
          <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
        </div>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';
import { ValidationProvider } from 'vee-validate';
import { cloneDeep } from 'lodash';

export default {
  name: 'StepTemplate',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  data() {
    return {
      mode: '1',
    };
  },

  methods: {
    /**
     * Select all available consultations.
     */
    selectAllAvailableConsultations() {
      this.$emit('input', {
        ...this.form,
        consultations: cloneDeep(this.consultations),
      });
    },

    /**
     * Deselect all available consultations.
     */
    deselectAllAvailableConsultations() {
      this.$emit('input', {
        ...this.form,
        consultations: [],
      });
    },

    cleanSelections() {
      this.$emit('input', {
        ...this.form,
        consultations: [],
        template: [],
      });
    },
  },

  computed: {
    ...mapState('compliance', {
      consultations: 'availableConsultations',
    }),
    ...mapState('compliance', {
      templates: 'availableTemplates',
    }),
  },

  components: {
    ValidationProvider,
    Multiselect,
  },
};
</script>

<style scoped>

</style>
